'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import UIModal from 'UIComponents/dialog/UIModal';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import H2 from 'UIComponents/elements/headings/H2';
import { FormattedMessage } from 'LearningCenterUI/components/I18n';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIButton from 'UIComponents/button/UIButton';

const PracticalExerciseResubmitButtonContainer = (_ref) => {
  let {
    exerciseName,
    onConfirm
  } = _ref,
      restProps = _objectWithoutPropertiesLoose(_ref, ["exerciseName", "onConfirm"]);

  const [showModal, setShowModal] = useState(false);
  const handleClickResubmit = useCallback(() => {
    setShowModal(true);
  }, []);
  const handleClickClose = useCallback(() => {
    setShowModal(false);
  }, []);
  const handleClickConfirm = useCallback(() => {
    onConfirm();
    setShowModal(false);
  }, [onConfirm]);
  const handleClickReject = useCallback(() => {
    setShowModal(false);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showModal && /*#__PURE__*/_jsxs(UIModal, {
      children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
        children: [/*#__PURE__*/_jsx(H2, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.resubmitModal.title",
            options: {
              exerciseName
            }
          })
        }), /*#__PURE__*/_jsx(UIDialogCloseButton, {
          onClick: handleClickClose
        })]
      }), /*#__PURE__*/_jsx(UIDialogBody, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.practicalExercise.resubmitModal.description"
        })
      }), /*#__PURE__*/_jsxs(UIDialogFooter, {
        children: [/*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "practical-exercise-resubmit-modal-confirm",
          onClick: handleClickConfirm,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.resubmitModal.confirm"
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          onClick: handleClickReject,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.practicalExercise.resubmitModal.reject"
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(UIButton, Object.assign({
      onClick: handleClickResubmit,
      use: "secondary"
    }, restProps, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.practicalExercise.resubmit"
      })
    }))]
  });
};

PracticalExerciseResubmitButtonContainer.propTypes = {
  exerciseName: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired
};
export default PracticalExerciseResubmitButtonContainer;